import React from 'react';
import { useAgentConfig } from '../contexts/AgentConfigContext';
import Dropdown from '../common_jsx/Dropdown';
import { AlertTriangle, Check } from 'lucide-react';

const AgentSelector = () => {
  const { config, selectedAgentIndex, selectAgent, availableAgents, isLoading, error } = useAgentConfig();

  // A picker with one option is not a choice — a deployment with a single agent
  // gets no control at all, in every place this mounts. After the load and
  // error branches below, because "still counting" and "cannot count" are not
  // the same as "counted one".
  if (!isLoading && !error && (availableAgents || []).length < 2) {
    return null;
  }

  // Show loading state
  if (isLoading) {
    return (
      <div className="agent-selector">
        <button
          style={{
            background: 'var(--bg-surface)',
            border: '1px solid var(--line)',
            borderRadius: '12px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '500',
            color: 'var(--fg-muted)',
          }}
          disabled
        >
          <span
            className="inline-block w-4 h-4 border-2 border-t-transparent rounded-full animate-spin mr-2"
            style={{ borderColor: 'var(--fg-muted)', borderTopColor: 'transparent' }}
          ></span>
          Loading agents...
        </button>
      </div>
    );
  }

  // Show error state
  if (error) {
    return (
      <div className="agent-selector">
        <button
          style={{
            background: 'var(--danger-soft)',
            border: '1px solid var(--danger)',
            borderRadius: '12px',
            padding: '8px 16px',
            fontSize: '14px',
            fontWeight: '500',
            color: 'var(--danger)',
          }}
          disabled
        >
          <AlertTriangle className="w-4 h-4 mr-2 inline-block" />
          Error loading agents
        </button>
      </div>
    );
  }

  const dropdownItems = availableAgents.map((agent, index) => ({
    name: agent.name,
    onClick: () => selectAgent(index),
    isSelected: selectedAgentIndex === index,
    icon: selectedAgentIndex === index ? (
      <div
        className="w-[18px] h-[18px] rounded-full flex items-center justify-center mr-2"
        style={{ background: 'var(--brand)' }}
      >
        <Check className="w-3.5 h-3.5" style={{ color: 'var(--brand-fg)', strokeWidth: 3 }} />
      </div>
    ) : (
      <div
        className="w-[18px] h-[18px] rounded-full mr-2"
        style={{ border: '2px solid var(--line)' }}
      ></div>
    )
  }));

  const heading = {
    icon: null,
    name: config.name
  };

  const buttonStyle = {
    background: 'var(--bg-surface)',
    border: '1px solid var(--line)',
    borderRadius: '12px',
    padding: '10px 16px',
    fontSize: '14px',
    fontWeight: '500',
    color: 'var(--fg-primary)',
    boxShadow: 'var(--shadow-soft)',
    transition: 'all 0.2s ease',
  };

  return (
    <div className="agent-selector w-full">
      <Dropdown
        heading={heading}
        items={dropdownItems}
        type="button"
        customStyle={buttonStyle}
        fullWidth
      />
    </div>
  );
};

export default AgentSelector;
